
// zajistuje dalsi zmeny vzhledu v detailu produktu pri zmene varianty

document.addEventListener('DOMContentLoaded', function () {
    const variationForm = document.querySelector('.variations_form'); // Formulář variant
    const targetDiv = document.querySelector('.product-lector'); // Element pro aktualizaci obsahu

    if (variationForm && targetDiv) {
        // Sledování změn v hodnotě variation_id
        const observer = new MutationObserver(() => {
            const variationIdInput = variationForm.querySelector('input[name="variation_id"]');
            const variationId = variationIdInput ? variationIdInput.value : null;

            if (variationId) {
                // console.log('Změna varianty, ID:', variationId);

                // AJAX požadavek pro získání obsahu varianty
                fetch(ajaxurl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    body: new URLSearchParams({
                        action: 'get_variation_template',
                        variation_id: variationId,
                        product_id: variationForm.getAttribute('data-product_id'), // ID produktu
                    }),
                })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data.success) {
                            targetDiv.innerHTML = data.data.content; // Aktualizace obsahu
                        } else {
                            console.error('Chyba při načítání obsahu:', data.data.message);
                        }
                    })
                    .catch((error) => {
                        console.error('Chyba při AJAX požadavku:', error);
                    });
            } else {
                // console.log('Žádná platná varianta nebyla vybrána.');
                // targetDiv.innerHTML = '<p>Vyberte platnou variantu produktu.</p>';
            }
        });

        // Připojení pozorovatele ke skrytému poli variation_id
        const variationIdInput = variationForm.querySelector('input[name="variation_id"]');
        if (variationIdInput) {
            observer.observe(variationIdInput, { attributes: true, attributeFilter: ['value'] });
        }
    }
});

/*
jQuery(function ($) {
    $('form.variations_form').on('found_variation', function (event, variation) {
        if (variation._custom_time_field_product_field) {
            $('#custom_time_field').text(variation._custom_time_field_product_field + ' hod');
            $('#custom_time_field_container').show();
        } else {
            $('#custom_time_field_container').hide();
        }
    });
});

*/
jQuery(document).on('found_variation', 'form.variations_form', function (event, variation) {
    // Přesuň informace o variantě do vlastního divu
    jQuery("#price-place").html(`     
       ${variation.display_price} Kč
       ${variation.availability_html}
    `);

});

jQuery(function ($) {
    // jQuery('.woocommerce').block();

    $('body').on('change', 'input.qty', function () {
        var $this = $(this);
        var $form = $('.woocommerce-cart-form');

        // Zjistíme, zda existuje tlačítko pro aktualizaci košíku
        var updateButton = $form.find('button[name="update_cart"]');

        if (updateButton.length) {
            updateButton.prop('disabled', false); // Povolit tlačítko (WooCommerce ho občas disabluje)
            updateButton.trigger('click'); // Simulujeme kliknutí na tlačítko
        }
    });
});





//$(document.body).trigger('wc_fragment_refresh');